import { CheckboxField } from '../../../fields/CheckboxField';
import { formField, FormFieldTypes } from '../../internal/form-field.hoc';
export var FormCheckboxField = formField(FormFieldTypes.Checkbox)(CheckboxField);